import { forwardRef } from "react";

import { cn } from "../../utils/cn";
import { useDrawerContext } from "./context";

import type { HTMLAttributes, ReactNode } from "react";

export interface DrawerFooterProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const DrawerFooter = forwardRef<HTMLDivElement, DrawerFooterProps>(
  ({ children, className, ...props }, ref) => {
    const { slots, classNames } = useDrawerContext();

    return (
      <footer
        ref={ref}
        className={slots.footer({ className: cn(classNames?.footer, className) })}
        data-slot="footer"
        {...props}
      >
        {children}
      </footer>
    );
  }
);
DrawerFooter.displayName = "Drawer.Footer";
